import { forwardRef, type Ref } from 'react';
import { ImageComponent } from '@/components/Image';
import {
  ScSlideColBadge,
  ScSlideColCard,
  ScSlideColTextBlock,
} from '@/modules/vip/ComparisonSection/components/ComparisonSlider/styled';
import {
  ScHeaderLevelLabel,
  ScHeaderSubTitle,
  ScHeaderTitleSlider,
} from '@/modules/vip/ComparisonSection/components/ComparisonTable/styled';
import type { IComparisonUICol } from '@/modules/vip/ComparisonSection/types';

interface ISlideColHeaderProps {
  col: IComparisonUICol;
  colIndex: number;
}

export const SlideColHeader = forwardRef<HTMLDivElement, ISlideColHeaderProps>(
  ({ col, colIndex }, ref: Ref<HTMLDivElement>) => (
    <ScSlideColCard $colIndex={colIndex} ref={ref}>
      <ScSlideColBadge>
        <ImageComponent
          alt={col.title}
          height={52}
          src={col.badgeUrl}
          width={52}
        />
      </ScSlideColBadge>

      <ScSlideColTextBlock>
        <ScHeaderTitleSlider>{col.title}</ScHeaderTitleSlider>
        <ScHeaderSubTitle>{col.subTitle}</ScHeaderSubTitle>
        <ScHeaderLevelLabel>{col.levelLabel}</ScHeaderLevelLabel>
      </ScSlideColTextBlock>
    </ScSlideColCard>
  )
);

SlideColHeader.displayName = 'SlideColHeader';
